function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 24,
  r: 24,
  fill: "#6B7280"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1058_2812)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.5 33.3333C26.788 33.3333 27.8333 34.3787 27.8333 35.6667C27.8333 36.9547 26.788 38 25.5 38C24.212 38 23.1667 36.9547 23.1667 35.6667C23.1667 34.3787 24.212 33.3333 25.5 33.3333ZM13.2477 38C12.55 38 10.4138 35.9537 10.0428 32.9787C9.54817 28.9957 12.5208 26.4535 15.1913 26.1303C15.8762 23.9195 18.0788 20.6657 22.6977 20.5653C23.582 18.253 26.6748 15.3072 30.6777 16.8483C32.5992 17.588 34.2955 19.2995 35.0002 21.2082C35.2697 21.9362 34.1718 22.334 33.907 21.613C33.312 20.0053 31.8805 18.5622 30.2588 17.9368C27.2523 16.7818 24.7813 18.7897 23.9332 20.6178C25.2247 20.7578 26.3738 21.1487 27.1473 21.655C28.2078 22.348 28.8658 23.4727 28.9067 24.6615C28.9428 25.6987 28.5217 26.6297 27.7505 27.213C26.9875 27.7917 26.0098 27.9632 25.0695 27.6843C23.9425 27.3507 23.0302 26.429 22.5693 25.1538C22.2345 24.2287 22.1213 22.999 22.3617 21.746C18.787 21.9618 17.0685 24.4363 16.4408 26.1117C17.8175 26.2307 19.0203 26.7813 19.7437 27.2923C20.8625 28.081 21.4902 29.159 21.5088 30.3245C21.5263 31.3267 21.0853 32.2658 20.3293 32.8387C19.62 33.3753 18.5385 33.5375 17.5725 33.2447C16.4513 32.9075 15.5892 32.0302 15.147 30.7737C14.8495 29.9302 14.7095 28.7017 14.909 27.3682C13.0062 27.7893 10.8117 29.6957 11.2013 32.834C11.4113 34.5233 12.3773 36.2033 13.5522 36.9197C14.0538 37.2242 13.8345 38 13.2477 38ZM33.4403 26.303L34.8462 28.8988L37.75 29.4343L35.7153 31.5728L36.1038 34.5L33.4403 33.226L30.7768 34.5L31.1653 31.5728L29.1307 29.4343L32.0345 28.8988L33.4403 26.303ZM16.1153 27.262C15.8797 28.4567 15.966 29.5872 16.2472 30.3863C16.652 31.5343 17.3742 31.9672 17.9085 32.127C18.6132 32.3405 19.2793 32.169 19.6258 31.9088C20.0785 31.5658 20.3538 30.9662 20.3422 30.3455C20.3293 29.5603 19.8778 28.8137 19.0705 28.2443C18.4347 27.7952 17.345 27.3075 16.1153 27.262ZM23.5505 21.76C23.2868 22.9477 23.4222 24.0817 23.666 24.7572C24.0008 25.6788 24.632 26.3392 25.3997 26.5655C25.9842 26.7382 26.5827 26.6355 27.0458 26.2832C27.5102 25.932 27.7633 25.3557 27.7412 24.7023C27.712 23.8798 27.264 23.1238 26.5092 22.6315C25.913 22.2418 24.8198 21.865 23.5505 21.76ZM15 10L16.7127 13.1628L20.25 13.8138L17.772 16.4202L18.2445 19.9867L15 18.4338L11.7555 19.9867L12.228 16.4202L9.75 13.8138L13.2873 13.1628L15 10V10ZM34.8333 10C36.4433 10 37.75 11.3067 37.75 12.9167C37.75 14.5267 36.4433 15.8333 34.8333 15.8333C33.2233 15.8333 31.9167 14.5267 31.9167 12.9167C31.9167 11.3067 33.2233 10 34.8333 10Z",
  fill: "#111827"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1058_2812"
}, /*#__PURE__*/React.createElement("rect", {
  width: 28,
  height: 28,
  fill: "white",
  transform: "translate(9.75 10)"
})));

function SvgLose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLose);
export default __webpack_public_path__ + "static/media/lose.b5cc375037263c11ffae5acf47584167.svg";
export { ForwardRef as ReactComponent };